Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.UseWorkCalendarOptionView extends Backbone.View
  template: JST['backbone/templates/customer_visual_mode/charts/use_work_calendar_option']
  tagName: 'li'

  events:
    'click': '_toggleUseWorkCalendar'

  initialize: ({isUsingWorkCalendar}) ->
    @displayText = if isUsingWorkCalendar then @_notUseWorkCalendar() else @_useWorkCalendar()
    @toggleEventName = 'chart:toggleUseWorkCalendar'

  render: ->
    @$el.html @template
      displayText: @displayText
    @

  getToggleMethod: (chartView) ->
    chartView.toggleUseWorkCalendar

  _toggleUseWorkCalendar: ->
    @_toggleText()
    @trigger(@toggleEventName)

  _toggleText: ->
    @displayText = if @displayText == @_useWorkCalendar() then @_notUseWorkCalendar() else @_useWorkCalendar()
    @render()

  _notUseWorkCalendar: ->
    I18n.t('customer_visual_mode.charts.not_use_work_calendar')

  _useWorkCalendar: ->
    I18n.t('customer_visual_mode.charts.use_work_calendar')
